export const GATEWAY_TYPE_CYBERSOURCE = 7;
export const GATEWAY_TYPE_STRIPE = 14;
export const GATEWAY_TYPE_SQUARE = 33;
export const GATEWAY_TYPE_ADYEN = 35;
export const GATEWAY_TYPE_WORLDPAY = 36;
export const GATEWAY_TYPE_PAYPAL = 4;
